module.exports = __webpack_public_path__ + "img/zizhi-about.22c96292.png";